<form [formGroup]="changePasswordForm">

  <input type="password" class="form-control required mb-2" formControlName="newPassword" placeholder="New Password" />
  <input type="password" class="form-control required mb-2" formControlName="confirmPassword" placeholder="Confirm Password" />

  <button class="btn btn-secondary w-100 mb-2" (click)="returnHome()">Cancel</button>
  <button class="btn btn-primary w-100" (click)="changePassword()">Change Password</button>

  @if(!validityModel.allValid || !arePasswordsTheSame()){
    <div class="alert alert-danger mt-2">
      <ul>
        <li [hidden]="validityModel.isValidLength">Passwords need to be at least eight characters</li>
        <li [hidden]="validityModel.hasLowercase">Passwords require a lowercase character</li>
        <li [hidden]="validityModel.hasUppercase">Passwords require an uppercase character</li>
        <li [hidden]="validityModel.hasNumerical">Passwords require a numerical character</li>
        <li [hidden]="validityModel.hasSpecial">Passwords require a special character</li>
        <li [hidden]="arePasswordsTheSame()">Passwords need to match</li>
      </ul>
    </div>
  }
  @if(validityModel.allValid && arePasswordsTheSame()){
    <div class="alert alert-success mt-2">
      <ul>
        <li>Good to go!</li>
      </ul>
    </div>
  }

</form>
